import "./announcements.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import tripleBright from "../../media/images/Annnouncements/K18_TripleBright_15.jpg";
import dagny from "../../media/images/Annnouncements/dagny_406.jpg";
import partnershipBG from "../../media/images/Annnouncements/partnershipBG.jpg";
import extensionsBG from "../../media/images/Annnouncements/extensionsBG.jpg";
import { useNavigate } from "react-router-dom";
import ga from "../../googleAnalytics";

const currentAnnouncementsInfo = [
	{
    text: {
      fin: "Kampaamomme on ekologinen sekä toimii vastuullisesti. Valitsemme käyttöömme laadukkaita, ympäristöä kunnioittavia hiustenhoito- ja värisarjoja. Käyttämämme tuotteet ovat eläinkokeettomia ja valikoimastamme löytyy rumsaasti vegaanisia vaihtoehtoja.",
      eng: "Our salon is commited to sustainability and responsible practices. Carefully selecting high quality hair care and colour brands that respect the environment. The products we use are cruelty-free, and our range includes a wide selection of vegan options.",
      swe: "Vår hårsalong arbetar hållbart och ansvarsfullt och väljer noggrant högkvalitativa hårvårds- och färgserier med hänsyn till miljön. Produkterna vi använder är cruelty-free och i vårt sortiment finns ett brett utbud av veganska alternativ.",
    },
    id: "ekological",
    layout: {
      offset: 0,
      span: 6,
    },
    cssOptions: {
      backgroundPosition: "center",
      backgroundImage: `url(${partnershipBG})`,
    },
    button: {
      show: false,
    },
  },
  {
    text: {
      fin: "Uusin K18 Triple Bright Shampoo on nyt saatavilla meiltä.",
      eng: "The latest K18 Triple Bright Shampoo is now available with us.",
      swe: "Nu finns det senaste K18 Triple Bright-schampot hos oss.",
    },
    id: "triple_bright_announcements",
    layout: {
      offset: 0,
      span: 6,
    },
    cssOptions: {
      backgroundPosition: "100% 75%",
      backgroundImage: `url(${tripleBright})`,
    },
    button: {
      show: false,
    },
  },
  {
    text: {
      fin:"UUTUUS! Löytyy nyt meiltä: Dagny on sävyttävä' sekä kiiltoa antava tehohoitoaine. Suunniteltu ja testattu Suomessa, vegaaninen.",
      eng: "NEW! Now available: Dagny is a colour-enhancing intensive conditioner that adds beautiful shine to your hair. Designed and tested in Finland, vegan.",
      swe: "NYHET! Nu hos oss: Dagny är ett tonande, glansgivande intensivbalsam. Utvecklat och testat i Finland, veganskt.",
    },
    id: "dagny_announcements",
    layout: {
      offset: 0,
      span: 6,
    },
    cssOptions: {
      backgroundPosition: "center",
      backgroundImage: `url(${dagny})`,
    },
    button: {
      show: false,
    },
  },
  {
    text: {
      fin: "Meillä tehdään myös hiustenpidennyksiä! Käytössämme ovat teippi-, beaded weft-, sekä mago- hiustenpidennystekniikat. ",
      eng: "We also do hair extentions! We use tape-, beaded weft-, and mago- hairextension techniques.",
      swe: "Vi gör även hårförlängningar! Vi använder tejp-, beaded weft-, och mago hårförlängningstekniker.",
    },
    id: "extensions",
    layout: {
      offset: 0,
      span: 6,
    },
    cssOptions: {
      backgroundPosition: "center",
      backgroundImage: `url(${extensionsBG})`,
    },
    button: {
      show: true,
      text: {
        fin: "Lue lisää",
        eng: "Read more",
        swe: "Läs mer",
      },
    },
  },
];

export const Announcements = ({ language }) => {
  return (
    <Container>
      <Row>
        <Col xs={{ span: 12, offset: 0 }} md={{ span: 10, offset: 1 }}>
          <Row>
            {currentAnnouncementsInfo.map((item, i) => {
              return (
                <Col
                  md={item.layout}
                  data-aos={i % 2 === 0 ? "fade-right" : "fade-left"}
                  data-aos-delay="50"
                  data-aos-duration="1000"
                  data-aos-mirror="false"
                  data-aos-once="true"
                  key={i}
                >
                  <ContentItem
                    language={language}
                    id={item.id}
                    info={
                      language === "eng"
                        ? item.text.eng
                        : language === "swe"
                        ? item.text.swe
                        : item.text.fin
                    }
                    cssOptions={item.cssOptions}
                    button={item.button}
                  />
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
    </Container>
  );
};

const ContentItem = ({ language, info, id, cssOptions, button }) => {
  const navigate = useNavigate();
  const handleNavigate = (location) => {
    ga.trackGAEvent(
      "frontpage_button_click",
      "frontpage_announcement_extensions_read_more",
      location
    );
    navigate(location);
  };
  return (
    <div className="content-item" style={cssOptions}>
      <div className="anouncement-content" id={id}>
        <div>{info}</div>
        {button.show === true && (
          <div>
            <Button
              className="announcement-item-button"
              onClick={() => handleNavigate("/uutuudet")}
            >
              {language === "eng"
                ? button.text.eng
                : language === "swe"
                ? button.text.swe
                : button.text.fin}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
